import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'react-bootstrap';
import ContactBanner from '../../components/contactBanner/ContactBanner';
import TableCollapse from '../../components/tableCollapse';
import './terms.scss';

function TermsPage() {
    const { t } = useTranslation();

    const [isOpened, setIsOpened] = useState(false);
    const [isPrivacyOpened, setIsPrivacyOpened] = useState(false);

    const toggleCollapse = () => {
        setIsOpened(!isOpened);
    };

    const togglePrivacyCollapse = () => {
        setIsPrivacyOpened(!isPrivacyOpened);
    };

    return (
        <>
            <Helmet>
                <title>{t('titles.terms')}</title>
            </Helmet>
            <div className="terms-page-wrapper">
                <div className="top-banner-outer-wrapper">
                    <Container>
                        <div className="top-banner-wrapper">
                            <h1
                                className="banner-header"
                                dangerouslySetInnerHTML={{
                                    __html: t('terms-page.terms-title')
                                }}
                            />
                            <h2 className="banner-sub-header">{t('terms-page.terms-text')}</h2>
                        </div>
                    </Container>
                </div>
                <section className="section-wrapper terms-section">
                    <Container>
                        <div className="section-top">
                            <h2
                                className="section-title"
                                dangerouslySetInnerHTML={{
                                    __html: t('terms-page.terms-title-small')
                                }}
                            />
                            <p className="section-text">{t('terms-page.terms-text-small')}</p>
                        </div>
                    </Container>
                    <div className="terms-content">
                        <Container>
                            <Row>
                                <Col lg={12}>
                                    <h4>{t('terms-page.terms-content.title')}</h4>
                                    <p>{t('terms-page.terms-content.date')}</p>
                                    <ol>
                                        <li>{t('terms-page.terms-content.text-1')}</li>
                                        <li>{t('terms-page.terms-content.text-2')}</li>
                                        <li>{t('terms-page.terms-content.text-3')}</li>
                                        <li>{t('terms-page.terms-content.text-4')}</li>
                                        <li>{t('terms-page.terms-content.text-5')}</li>
                                        <li>{t('terms-page.terms-content.text-6')}</li>
                                        <li>{t('terms-page.terms-content.text-7')}</li>
                                        <li>{t('terms-page.terms-content.text-8')}</li>
                                        <li>{t('terms-page.terms-content.text-9')}</li>
                                        <li>{t('terms-page.terms-content.text-10')}</li>
                                    </ol>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <div className="terms-info">
                        <Container>
                            <Row>
                                <Col md={12}>
                                    <p
                                        dangerouslySetInnerHTML={{
                                            __html: t('terms-page.terms-info-text')
                                        }}
                                    />
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </section>
                <section className="section-wrapper terms-collapse-section">
                    <Container>
                        <TableCollapse
                            isOpen={isOpened}
                            toggle={toggleCollapse}
                            id="section1"
                            title={
                                <>
                                    <h4>{t('terms-page.terms-collapse-title')}</h4>
                                    <p>{t('terms-page.terms-collapse-text')}</p>
                                </>
                            }
                        >
                            <div>
                                <ol>
                                    <li
                                        dangerouslySetInnerHTML={{
                                            __html: t('terms-page.terms-content-full.text-1')
                                        }}
                                    />
                                    <li>{t('terms-page.terms-content-full.text-2')}</li>
                                    <li>{t('terms-page.terms-content-full.text-3')}</li>
                                    <li>{t('terms-page.terms-content-full.text-4')}</li>
                                    <li>{t('terms-page.terms-content-full.text-5')}</li>
                                    <li>{t('terms-page.terms-content-full.text-6')}</li>
                                    <li>{t('terms-page.terms-content-full.text-7')}</li>
                                    <li
                                        dangerouslySetInnerHTML={{
                                            __html: t('terms-page.terms-content-full.text-8')
                                        }}
                                    />
                                    <li>{t('terms-page.terms-content-full.text-9')}</li>
                                    <li>{t('terms-page.terms-content-full.text-10')}</li>
                                    <li>{t('terms-page.terms-content-full.text-11')}</li>
                                    <li>{t('terms-page.terms-content-full.text-12')}</li>
                                    <li>{t('terms-page.terms-content-full.text-13')}</li>
                                    <li>{t('terms-page.terms-content-full.text-14')}</li>
                                    <li>{t('terms-page.terms-content-full.text-15')}</li>
                                    <li>{t('terms-page.terms-content-full.text-16')}</li>
                                    <li>{t('terms-page.terms-content-full.text-17')}</li>
                                    <li>{t('terms-page.terms-content-full.text-18')}</li>
                                    <li>{t('terms-page.terms-content-full.text-19')}</li>
                                    <li>{t('terms-page.terms-content-full.text-20')}</li>
                                    <li>{t('terms-page.terms-content-full.text-21')}</li>
                                    <li>{t('terms-page.terms-content-full.text-22')}</li>
                                    <li>{t('terms-page.terms-content-full.text-23')}</li>
                                </ol>
                            </div>
                        </TableCollapse>
                    </Container>
                    <Container>
                        <TableCollapse
                            isOpen={isPrivacyOpened}
                            toggle={togglePrivacyCollapse}
                            id="privacySection"
                            title={
                                <>
                                    <h4>{t('terms-page.privacy-collapse-title')}</h4>
                                    <p>{t('terms-page.privacy-collapse-text')}</p>
                                </>
                            }
                        >
                            <div className="privacy-content">
                                <Container>
                                    <Row>
                                        <Col lg={12}>
                                            <p>{t('terms-page.privacy-content.intro')}</p>
                                            <ol>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-1-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-1-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-2-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-2-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-3-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-3-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-4-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-4-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-5-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-5-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-6-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-6-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h6>
                                                        {t(
                                                            'terms-page.privacy-content.section-7-title'
                                                        )}
                                                    </h6>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-7-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                                <li>
                                                    <h5>
                                                        {t(
                                                            'terms-page.privacy-content.section-8-title'
                                                        )}
                                                    </h5>
                                                    <p
                                                        dangerouslySetInnerHTML={{
                                                            __html: t(
                                                                'terms-page.privacy-content.section-8-text'
                                                            )
                                                        }}
                                                    />
                                                </li>
                                            </ol>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </TableCollapse>
                    </Container>
                </section>
                <ContactBanner />
            </div>
        </>
    );
}

export default TermsPage;
